import CsvImporter from '../components/CsvImporter.jsx';

const MAPPING = {
  'Salutation': 'salutation',
  'First Name': 'first_name',
  'Last Name': 'last_name',
  'Department': 'department',
  'Division': 'division',
  'Company': 'company',
  'Web site': 'website',
  '3. Category': 'category',
  'Address Line 1': 'address1',
  'Address Line 2': 'address2',
  'City': 'city',
  'State / Province': 'province_state',
  'Zip / Postal Code': 'postal_zip',
  'Country': 'country',
  'Phone 1': 'phone_main',
  'Phone 3': 'phone_cell',
  'E-mail Address': 'email1',
  'E-mail Address 2': 'email2',
  'E-mail Address 3': 'email3',
  'Site Number': 'site_number',
  '3. POS Type': 'pos_type',
  '1. Current Status Of Lead': 'current_status',
  '2. Number In Chain': 'number_in_chain',
  'Last Contact': 'last_contact',
  'Next Contact': 'next_contact',
  'Position':              'position',
  'Fuel Brand':            'fuel_brand',
  'POS Type':              'pos_type',           // bare alias alongside '3. POS Type'
  'Close Probability':     'close_probability',
  'Expected Close Date':   'expected_close_date',
  'Next Contact Date':     'next_contact'        // bare alias alongside 'Next Contact'
};

const DATE_FIELDS = ['last_contact', 'next_contact', 'expected_close_date'];
const NUMERIC_FIELDS = ['number_in_chain', 'close_probability'];

const VALUE_TRANSFORMS = {
  // Maximizer sometimes prefixes POS Type values with asterisks. Strip them
  // so the value matches the database CHECK constraint.
  pos_type: (v) => v.replace(/^\*+/, '').trim()
};

const PREVIEW_COLUMNS = [
  'last_name', 'first_name', 'company', 'site_number', 'pos_type',
  'city', 'province_state', 'phone_main', 'email1', 'current_status', 'next_contact'
];

export default function LeadImport() {
  return (
    <CsvImporter
      title="Import Sales Leads from CSV"
      subtitle="Upload a Maximizer-format CSV. Columns are mapped automatically."
      backTo="/leads"
      backLabel="Back to Sales Leads"
      mapping={MAPPING}
      dateFields={DATE_FIELDS}
      numericFields={NUMERIC_FIELDS}
      valueTransforms={VALUE_TRANSFORMS}
      previewColumns={PREVIEW_COLUMNS}
      apiPath="/api/leads/bulk-import"
      successCta="View Sales Leads"
      successHint="All rows will be created as sales leads · POS Type asterisks stripped on import"
    />
  );
}
